import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { forViewer, usersQuery, viewerIdOf } from "../services/queries";

export const useUsers = (options?: { enabled?: boolean }) => {
  const { user, token } = useAuth();
  const orgId = user?.schoolId || user?.orgId;
  const queryEnabled = options?.enabled ?? true;

  return useQuery({
    ...forViewer(usersQuery(orgId, token), viewerIdOf(user)),
    enabled: !!orgId && !!token && queryEnabled,
  });
};
